0<template>
  <div class="withdraw-method-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="channelOperation('add')" class="add-input">+新增提现方式</el-button>
      <el-button type="success" size="small" icon="el-icon-edit" @click="editTax()">修改税率</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="channelName" label="提现平台" align="center" min-width="150" fixed>

        <template slot-scope="scope">
          <span>{{scope.row.channelName || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cid" label="平台ID" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.cid || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payType" label="提现方式" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.payType | payTypeRule}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cashTax" label="代理税率" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.cashTax || '0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="discCashTax" label="商区自提税率" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.discCashTax || '0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="discFinanceTax" label="商区财务税率" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.discFinanceTax || '0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinTax" label="金币税率" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.coinTax || '0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minMoney" label="最小支持金额(元)" align="center" min-width="150">

        <template slot-scope="scope">
          <span>{{(scope.row.minMoney / 100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="maxMoney" label="最大支持金额(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.maxMoney / 100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="qpMinMoney" label="棋牌最小支持金额(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.qpMinMoney / 100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="权重" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.weight || '0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="active" label="激活状态" align="center" min-width="150">
        <template slot-scope="scope">
          <el-switch disabled v-model="scope.row.active"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="240">

        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="channelOperation('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeChannel(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <channel-action ref="channelAction" @handlerChannelList="getChannelList"></channel-action>
    <!--编辑税率弹窗-->
    <edit-tax ref="editTax" @handlerChannelList="getChannelList"></edit-tax>
  </div>
</template>

<script>
import API from '@/api'
import ChannelAction from "./components/channelAction"
import EditTax from "./components/editTax"
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
    }
  },
  components: {
    ChannelAction,
    EditTax
  },
  created() {
    this.getChannelList()
  },
  methods: {
    // 请求提现方式列表
    getChannelList() {
      this.loading = true;
      API.getWChannelList().then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除提现方式配置
    removeChannel(id) {
      this.$confirm('您确定要删除当前提现方式吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.delWChannel({ ids: [id] }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除提现方式成功',
                type: 'success'
              })
              this.getChannelList()
            } else {
              this.$message.error('删除提现方式失败')
            }
          })
        })
        .catch(() => { });
    },
    // 新增、编辑操作
    channelOperation(type, data) {
      this.$refs.channelAction.open(type, data)
    },
    // 编辑操作
    editTax() {
      this.$refs.editTax.open(this.tableData[0])
    }
  }
}
</script>

<style lang="scss">
.withdraw-method-box {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
